import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import { MouseEventHandler } from 'react'

const CloseDialogButton = ({
    onClick,
    dialogName,
}: {
    onClick: MouseEventHandler<HTMLButtonElement>
    dialogName?: string
}) => {
    return (
        <IconButton
            aria-label={`close ${dialogName ?? 'dialog'}`}
            onClick={onClick}
            sx={() => ({
                position: 'absolute',
                right: 8,
                top: 10,
                color: 'white',
            })}
        >
            <CloseIcon fontSize="medium" />
        </IconButton>
    )
}
export default CloseDialogButton
